module.exports = __webpack_public_path__ + "static/paw-fbb24bff2a0254eaf5f5baf0cd6e045c.png";